// CSE (Client Side Encryption) SDK loader za Payten.
//
// WARNING: input polja za karticu NE SMEJU imati `name` atribut.
// Ako imaju, browser autocomplete ce sacuvati plain PAN i odsecanjem kroz form
// submit poslati ga u clearu. CSE SDK eksportuje `window.msu.client`.

let loadedForToken = null;

export function loadCseSdk(sdkUrl, sessionToken) {
    if (loadedForToken === sessionToken && typeof window !== "undefined" && window.msu?.client) {
        return Promise.resolve();
    }

    const existing = document.getElementById("payten-cse-sdk");
    if (existing) existing.remove();

    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.id = "payten-cse-sdk";
        script.src = sdkUrl;
        script.async = true;
        script.onload = () => {
            if (window.msu?.client) {
                loadedForToken = sessionToken;
                resolve();
            } else {
                reject(new Error("CSE SDK loaded but msu.client not available"));
            }
        };
        script.onerror = () => reject(new Error("Failed to load CSE SDK"));
        document.head.appendChild(script);
    });
}

function generateNonce() {
    const arr = new Uint8Array(8);
    crypto.getRandomValues(arr);
    return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function encryptCardData({ pan, cardHolderName, expiryMonth, expiryYear, cvv }) {
    const client = window.msu?.client;
    if (!client) throw new Error("CSE SDK not loaded");
    const nonce = generateNonce();
    return client.encrypt(pan, cardHolderName, expiryMonth, expiryYear, cvv, nonce);
}

export function detectCardBrandCse(panFirstSix) {
    const client = window.msu?.client;
    if (!client) return "unknown";
    try {
        return client.detectBrand(panFirstSix);
    } catch {
        return "unknown";
    }
}

export function validateCardFields({ pan, cardHolderName, expiryMonth, expiryYear }) {
    const client = window.msu?.client;
    if (!client) return { valid: false, errors: ["SDK_NOT_LOADED"] };
    const errors = [];
    if (!client.isValidPan(pan)) errors.push("PAN_INVALID");
    if (!client.isValidCardHolderName(cardHolderName)) errors.push("CARD_HOLDER_NAME_INVALID");
    if (!client.isValidExpiry(expiryMonth, expiryYear)) errors.push("EXPIRY_INVALID");
    return { valid: errors.length === 0, errors };
}
